import JSZip from "jszip";

export const createAndDownloadZip = async (fileName: string, files: any[]) => {
  try {
    const zip = new JSZip();
    const token = localStorage.getItem('token');
    for (const file of files) {
      const response = await fetch(file.url, {
        mode: "cors",
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const blob = await response.blob();
      zip.file(file.name, blob);
    }

    const content = await zip.generateAsync({ type: "blob"});
    const link = document.createElement("a");
    link.href = URL.createObjectURL(content);
    link.download = fileName;
    link.click();
  } catch (error){
    console.error('Error creating and downloading zip file', error);
  }

}